module.exports = __webpack_public_path__ + "static/media/IconTemplates_-57.62da8a9b.svg";